import React, { Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import { ButtonToolbar, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import validate from '../Validate';

const Form = (props) => {
  const { t, backHandler, handleSubmit, dto, initialize } = props;

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">
            Funcionalidade a ser implementada!
          </span>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" disabled type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

Form.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'PayableForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(Form));
